<template>
  <v-row justify="center">
    <v-col md="8" lg="6" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="editForm" v-model="valid">
          <v-card-title>
            <h2>{{ $t("user.resetPassword.title") }}</h2>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :label="$t('user.resetPassword.password')"
              :rules="[$v.required()]"
              type="password"
              v-model="user.password"
            ></v-text-field>

            <v-text-field
              :label="$t('user.resetPassword.confirmPassword')"
              :rules="[$v.required(), $v.passwordMatch(user.password)]"
              type="password"
              v-model="confirm"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">
              {{ $t("user.resetPassword.changePassword") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      user: {},
      confirm: null,
      valid: false,
    };
  },
  async mounted() {
    this.user = await this.$axios.get(`/user/resetpassword/${this.$route.params.token}`);
    if (!this.user) {
      this.$router.push({ name: "notFound" });
    }
  },
  methods: {
    async save() {
      if (!this.$data.valid) return;
      let user = await this.$axios.patch(`/user/resetpassword/${this.$route.params.token}`, this.user);
      if (user) {
        this.$store.commit("SUCCESS", this.$t("user.resetPassword.msgSaved"));
        this.$router.push("/login");
      }
    },
  },
};
</script>
